import router from "./../routes/router";
import store from "@/store/store";
import moment from "moment";
const commonMixin = {

    methods: {
        getArraysIntersection(a1, a2) {
            return a1.filter(function (n) { return a2.indexOf(n) !== -1; });
        },
        goBack() {
            this.$snotify.clear();
            if (this.$snotify.notifications.length > 0) {
                this.$snotify.notifications.forEach(notification => {
                    this.$snotify.remove(notification.id)
                });
            }
            window.history.back();
        },
        clearSnotifyMessages() {
            this.$snotify.clear();
            if (this.$snotify.notifications.length > 0) {
                this.$snotify.notifications.forEach(notification => {
                    this.$snotify.remove(notification.id)
                });
            }
        },
        claimDropDownLable(value) {
            let str = "";
            let fiscalYear = value.fiscalYear;
            let fiscalMonth = this.getMonthNameFormValue(value.fiscalMonth);
            let fiscalDay = value.fiscalDay;
            let claimType = this.ammendString(value.claimType);

            if (fiscalYear) {
                str = str + fiscalYear + " | ";
            }
            if (fiscalMonth) {
                str = str + fiscalMonth;
            }
            if (fiscalDay) {
                str = str + "  " + fiscalDay + " " + "FYE";
            }
            if (claimType) {
                str = str + " | " + claimType;
            }
            return str;
        },
        claimDropDownLabelWithCLientName(value) {
            let str = value.client.name + " | ";
            let fiscalYear = value.fiscalYear;
            let fiscalMonth = this.getMonthNameFormValue(value.fiscalMonth);
            let fiscalDay = value.fiscalDay;
            let claimType = this.ammendString(value.claimType);

            if (fiscalYear) {
                str = str + fiscalYear + " | ";
            }
            if (fiscalMonth) {
                str = str + fiscalMonth;
            }
            if (fiscalDay) {
                str = str + "  " + fiscalDay + " " + "FYE";
            }
            if (claimType) {
                str = str + " | " + claimType;
            }
            return str;
        },
        ammendString(type) {
            let amendStr = "";
            if (type == 1) {
                amendStr = "Amended";
            } else if (type == 2) {
                amendStr = "Non-Amended";
            }
            return amendStr;
        },
        proxyString(claim) {
            let proxyStr = "";
            if (claim && claim.proxy) {
                if (claim.proxy == 1) {
                    proxyStr = "PROXY";
                } else if (claim.proxy == 2) {
                    proxyStr = "NON_PROXY";
                }
            }
            return proxyStr;
        },
        getMonthNameFormValue(val) {
            const monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"];
            return monthNames[val - 1];
        },
        claimTypeStr(data) {
            let str = "";
            let amendStr = this.ammendString(data.claimType);
            if (data.claimType == 1) {
                str = "Traditional";
            } else if (data.claimType == 2) {
                str = "Proxy";
            }
            str = str + " , " + amendStr;
            return str;
        },
        claimTypeValueStr(data) {
            let str = "";
            if (data) {
                if (data.claimType == 1) {
                    str = "Traditional";
                } else if (data.claimType == 2) {
                    str = "Proxy";
                }
            }
            str = str;
            return str;
        },
        claimFyeStr(value) {
            return (
                value.fiscalYear +
                " | " +
                this.getMonthNameFormValue(value.fiscalMonth) +
                " " +
                value.fiscalDay +
                " " +
                "FYE"
            );
        },
        claimStatusIdToString(status) {

            const statusNames = ["Unknown", "Created", "Assigned", "Work In Progress", "Accountant", "Government", "Review", "Audit", "Withdrawn", "Denied", "Appeals", "TaxCourt", "Doubtful", "TentativeApproval", "PartialApproval", "FTCAS", "Approved", "Invoiced", "Delinquent", "BadDebt", "Paid", "PaidPartial", "NoClaimDone"]

            if (status >= 0 && status <= 22) {
                return statusNames[status];
            }
            else {
                return "Unknown";
            }
        },

        claimStatusStringtoId(status) {

            const statusMap = new Map([
                ["Unknown", 0],
                ["Created", 1],
                ["Assigned", 2],
                ["Work In Progress", 3],
                ["Accountant", 4],
                ["Government", 5],
                ["Review", 6],
                ["Audit", 7],
                ["Withdrawn", 8],
                ["Denied", 9],
                ["Appeals", 10],
                ["TaxCourt", 11],
                ["Doubtful", 12],
                ["TentativeApproval", 13],
                ["PartialApproval", 14],
                ["FTCAS", 15],
                ["Approved", 16],
                ["Invoiced", 17],
                ["Delinquent", 18],
                ["BadDebt", 19],
                ["Paid", 20],
                ["PaidPartial", 21],
                ["NoClaimDone", 22]
            ]);

            if (statusMap.has(status)) {
                return statusMap.get(status);
            }
            else {
                return 0;
            }
        },

        getFileExtImg(ext) {
            if (ext == "DOC" || ext == ".DOC" || ext == ".docx") {
                return '<i class="fa-regular fa-file-word fa-2x blue-font"></i>';
            } else if (ext == "PDF" || ext == ".PDF" || ext == ".pdf") {
                return '<i class="fa-solid fa-file-pdf fa-2x red-font"></i>';
            } else if (ext == "CSV" || ext == ".CSV" || ext == ".csv") {
                return '<i class="fa-solid fa-file-csv fa-2x red-font"></i>';
            } else if (ext == "EXCEL" || ext == ".EXCEL" || ext == ".xlsx") {
                return '<i class="fas fa-file-excel fa-2x green-font"></i>';
            } else {
                return '<i class="fas fa-file fa-2x blue-font"></i>';
            }
        },
        redirectToHome() {

            this.$store.state.claim = "";
            this.$store.state.client = "";
            this.$store.state.client_name = "";
            this.$store.state.activeClaim = null;
            this.$store.state.documetList = [];

            if(this.$route.name == "reviewpage" && window.location.href && window.location.href.split('?').length > 1){
                window.location.replace('/');
            }else{
                router.push({
                    name: "home"
                });
            }
        },
        checkIfClaimHasPermission(claim) {
            if (claim) {
                if (claim.analystId == this.$store.state.user.user_id ||
                    this.$store.state.user.is_admin == true) {
                    console.log("User is admin");
                    return true;
                } else {
                    console.log("User is not admin");
                    return false;
                }
            } else {
                return false;
            }
        },
        redirectToClaimWizard() {
            router.push({
                name: "claimwizard"
            });
        },
        redirectToUserMgt() {
            router.push({
                name: "usermanagement"
            });
        },
        validSharePointURL(str) {
            const pattern = new RegExp('(docs.google.com|(http|https))(://[A-Za-z]+-my.sharepoint.com)?', 'i');
            return pattern.test(str);
        },
        convertToThousandSeperators(str) {
            if (str) {
                let num = Number(str).toFixed(2);
                return Number(num).toLocaleString();
            } else {
                return str;
            }

        },
        truncateText(text) {
            return this.$options.filters.truncate(text, 60, "...");
        },
        multiFileUploadString(rowData) {
            let fileStr = [];
            for (let fileCount = 1; fileCount <= 5; fileCount++) {
                if (rowData['fileName_' + fileCount]) {
                    fileStr.push(rowData['fileName_' + fileCount]);
                }
            }
            if (fileStr.length) {
                return fileStr.join(', ');
            } else {
                return "N/A";
            }
        },
        getIndustryTypeString(ind) {
            if (ind == 0) {
                return 'NON-SELCTED';
            } else if (ind == 1) {
                return 'TECH';
            } else if (ind == 2) {
                return 'MEDICAL';
            } else if (ind == 3) {
                return 'INDUSTRIAL';
            }
            else {
                return 'NON-SELCTED';
            }
        },
        convertDateValues(date) {
            if (date) {
                let dateStr = moment(new Date(date)).format("YYYY-MM-DD");
                if (dateStr != "0001-01-01") {
                    return dateStr;
                } else {
                    return "";
                }
            } else {
                return "";
            }
        },
        convertFormatDateValues(date) {
            if (date) {
                let dateStr = moment(new Date(date)).format("YYYY-MM-DD");
                if (dateStr != "0001-01-01") {
                    return moment(new Date(date)).format("MM/DD/YY");;
                } else {
                    return "";
                }
            } else {
                return "";
            }
        },
        updateByCsStr(updatedBy, UpdatedOn) {
            let updatedStr = "";
            if (updatedBy) {
                updatedStr = "Last Modified : " + this.convertFormatDateValues(UpdatedOn) + " " + updatedBy.firstName + " " + updatedBy.lastName;
                //Last Modified : 04/11/21 by UserName
            }
            return updatedStr;
        },
        updateByTrStr(updatedBy, UpdatedOn) {

            let updatedStr = "";
            if (updatedBy) {
                updatedStr = "Last Modified : " + this.convertFormatDateValues(UpdatedOn) + " " + updatedBy.firstName + " " + updatedBy.lastName;
                //Last Modified : 04/11/21 by UserName
            }
            return updatedStr;
        },
        publishedStr(updatedBy, UpdatedOn) {

            let updatedStr = "";
            if (updatedBy) {
                updatedStr = "Last Modified : " + this.convertFormatDateValues(UpdatedOn) + " " + updatedBy.firstName + " " + updatedBy.lastName;
            }
            return updatedStr;
        },
        internalReviewClassStr(status) {
            let internal_review_class = "";
            if (status == 0) {
                internal_review_class = "fa fa-exclamation-circle";
            } else if (status == 1) {
                internal_review_class = "fa-clock-rotate-left";
            } else if (status == 5) {
                internal_review_class = "fa fa-check";
            } else {
                internal_review_class = "fa-clock-rotate-left";
            }
            return internal_review_class;
        }
    }
}

export default commonMixin

